import DesignAdvancedView from './DesignAdvancedView'

export default DesignAdvancedView
